import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import BatchesSection from '@/sections/Fulfill/Batches';

const BatchesPage = () => {
  usePageTitle('Fulfill99 - Lotes');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Lotes" mt={5}>
        <LayersOutlinedIcon fontSize="large" sx={{ color: 'secondary.main' }} />
      </SectionTitle>
      <BatchesSection />
    </Container>
  );
};

export default BatchesPage;
